<script>
  import AtomRadioButton from "@/components/atoms/AtomRadioButton.vue";

  export default {
    name: "MoleculePlatformTypeSelector",
    components: { AtomRadioButton },
    props: {
      subjectType: { type: String, required: true },

      value: {
        type: [String, Array],
        default: null,
      },

      label: { type: String, default: "Tipo de plataforma" },
      disabled: { type: Boolean, default: false },

      name: { type: String, default: "platformType" },
    },
    computed: {
      shouldRender() {
        const ROLE_VALID_OPTIONS = ["model", "monitor", "coordinator"];
        return ROLE_VALID_OPTIONS.includes(this.subjectType);
      },
      isCheckboxMode() {
        return ["monitor", "coordinator"].includes(this.subjectType);
      },
      options() {
        if (this.subjectType === "model") {
          return [
            { value: "private", label: "Privada" },
            { value: "free", label: "Free" },
          ];
        }

        if (["monitor", "coordinator"].includes(this.subjectType)) {
          return [
            { value: "private", label: "Privada" },
            { value: "free", label: "Free" },
            { value: "group", label: "Grupal" },
          ];
        }
        return [];
      },
      checkboxValues() {
        const raw = Array.isArray(this.value) ? this.value : this.value ? [this.value] : [];
        return [...new Set(raw)];
      },
      selectedValue() {
        if (this.isCheckboxMode) return null;
        if (Array.isArray(this.value)) return this.value[0] ?? null;
        return this.value;
      },
    },
    methods: {
      onSelect(val) {
        this.$emit("input", val);
      },
      isCheckedRadio(val) {
        return this.selectedValue === val;
      },
      isCheckedCheckbox(val) {
        return this.checkboxValues.includes(val);
      },
      toggleCheckbox(val) {
        if (this.disabled) return;

        const set = new Set(this.checkboxValues);
        if (set.has(val)) set.delete(val);
        else set.add(val);

        this.$emit("input", Array.from(set));
      },
    },
  };
</script>

<template>
  <fieldset v-if="shouldRender" class="platformType">
    <template v-if="isCheckboxMode">
      <div class="platformType__group platformType__group--checkbox" role="group" :aria-label="label">
        <label v-for="opt in options" :key="opt.value" class="platformType__checkbox">
          <input type="checkbox" :checked="isCheckedCheckbox(opt.value)" :disabled="disabled" @change="toggleCheckbox(opt.value)" />
          <span>{{ opt.label }}</span>
        </label>
      </div>
    </template>

    <template v-else>
      <div class="platformType__group" role="radiogroup" :aria-label="label">
        <AtomRadioButton
          v-for="opt in options"
          :key="opt.value"
          :name="name"
          :label="opt.label"
          :value="opt.value"
          :checked="isCheckedRadio(opt.value)"
          :disabled="disabled"
          @change.native="onSelect(opt.value)"
        />
      </div>
    </template>
  </fieldset>
</template>

<style lang="scss" scoped>
  .platformType {
    border: 0;
    margin: 0;
    padding: 0;

    &__legend {
      margin-bottom: 8px;
      color: #3d3d3d;
      font-size: 14px;
      font-weight: 500;
    }

    &__group {
      display: flex;
      align-items: center;
      gap: 24px;
      flex-wrap: wrap;
    }

    &__group--checkbox {
      gap: 12px;
    }

    &__checkbox {
      @include Flex(row, flex-start, center);
      gap: 8px;
      cursor: pointer;

      > input {
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: 1px solid #c4c4c4;
        appearance: none;
        background: white;
        cursor: pointer;

        &:checked {
          border: none;
          background-color: $primary-color;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='10' viewBox='0 0 12 10' fill='none'%3E%3Cpath d='M1 5L4 8.5L11 1.5' stroke='white' stroke-width='2'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: center;
          background-size: 12px 10px;
        }

        &:disabled {
          cursor: not-allowed;
          background-color: #f5f5f5;
          border-color: #dcdcdc;
        }
      }

      > span {
        color: #3d3d3d;
        font-size: 16px;
        font-weight: 500;
        user-select: none;
      }
    }
  }
</style>
